import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'VenueLiveStreams';

const VenueLiveStreamApi: any = baseApi(endpoint);

export default VenueLiveStreamApi;